const initialState = {
  info: false
}

const addLayer = (state = initialState, action) => {
  switch (action.type) {
    case "ADD_LAYER_MODAL":
      return { ...state, info: action.val }
    default:
      return state
  }
}

export default addLayer
